package ui.search

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import linx.linxapp.generated.resources.Res
import linx.linxapp.generated.resources.merchants_near_me
import org.jetbrains.compose.resources.stringResource
import ui.scrollbar.LazyColumnScrollbar

@Composable
fun SearchScreen(
    viewModel: SearchViewModel = searchViewModel(),
) {

    val merchantsStateFlow = viewModel.filteredMerchantList
    val shouldShowScrollbar = viewModel.clientConfig.shouldShowScrollBar
    val searchTextFlow = viewModel.searchText

    val _merchants by merchantsStateFlow.collectAsState(null)
    val merchants = _merchants

    val _searchText by searchTextFlow.collectAsState(null)
    val searchText = _searchText ?: ""

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .fillMaxHeight(),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        val lazyListState = rememberLazyListState()

        /**
         * This if(false) is needed to disable/remove the Search text field.
         * Might need to be removed if the search field is required
         */
        if (false) {
            SearchTextField(searchText, viewModel::onSearchTextChange)
        }

        if (merchants != null) {
            LazyColumnScrollbar(
                listState = lazyListState,
                padding = 4.dp,
                alwaysShowScrollBar = shouldShowScrollbar,
            ) {
                LazyColumn(
                    state = lazyListState,
                    modifier = Modifier
                ) {
                    item {
                        Text(
                            stringResource(Res.string.merchants_near_me),
                            fontWeight = FontWeight.ExtraBold,
                            modifier = Modifier.align(Alignment.Start).padding(start = 16.dp, top = 16.dp, bottom = 16.dp),
                            fontSize = 20.sp
                        )
                    }
                    items(merchants) { merchant ->
                        MerchantNearMeCard(merchant, shouldDeactivateClickEffects = true)
                        HorizontalDivider(
                            color = Color.White,
                            thickness = 16.dp,
                        )
                    }
                }
            }
        } else {
            CircularProgressIndicator()
        }
    }
}

